const SET_CLIENT_LIST = "SET_CLIENT_LIST";
const SET_BANK_ACCOUNT_LIST = "SET_BANK_ACCOUNT_LIST";
const SET_Regions_List = "SET_Regions_List";
const SET_ACCOUNTPAYABLE_LIST = "SET_ACCOUNTPAYABLE_LIST";
const SET_CINEMA_LIST = "SET_CINEMA_LIST";
const SET_INVOICE_LIST = "SET_INVOICE_LIST";
const SET_PAGE_COUNT = "SET_PAGE_COUNT";
// const SET_NOTI_LIST = "SET_NOTI_LIST";

const createState = () => {
  return {
    clientList: [],
    bankAccountList: [],
    regionsList: [],
    accountPayableList: [],
    cinemaList: [],
    invoiceList: [],
    notiList: [],
    pageCount: 0,
  };
};

export default {
  namespaced: true,
  state: createState(),
  getters: {},
  mutations:{
    [SET_CLIENT_LIST](state, payload) {
      state.clientList = payload;
    },
    [SET_BANK_ACCOUNT_LIST](state, payload) {
      state.bankAccountList = payload;
    },
    [SET_Regions_List](state, payload) {
      state.regionsList = payload;
    },
    [SET_ACCOUNTPAYABLE_LIST](state, payload) {
      state.accountPayableList = payload;
    },
    [SET_CINEMA_LIST](state, payload) {
      state.cinemaList = payload;
    },
    [SET_INVOICE_LIST](state, payload) {
      state.invoiceList = payload;
    },
    [SET_PAGE_COUNT](state, payload) {
      state.pageCount = payload;
    }
    // [SET_NOTI_LIST](state, payload) {
    //   state.notiList = payload;
    // },
  },
  actions: {
    setClientList({ commit }, payload) {
      commit(SET_CLIENT_LIST, payload);
    },
    setBankAccountList({ commit }, payload) {
      commit(SET_BANK_ACCOUNT_LIST, payload);
    },
    setRegionsList({ commit }, payload) {
      commit(SET_Regions_List, payload);
    },
    setAccountPayableList({ commit }, payload) {
      commit(SET_ACCOUNTPAYABLE_LIST, payload);
    },
    setCinemaList({ commit }, payload) {
      commit(SET_CINEMA_LIST, payload);
    },
    setInvoiceList({ commit }, payload) {
      commit(SET_INVOICE_LIST, payload);
    },
    setPageCount({ commit }, payload) {
      commit(SET_PAGE_COUNT, payload);
    }
    // setNotiList({ commit }, payload) {
    //   commit(SET_NOTI_LIST, payload);
    // },
  }
};
